import { RouterProvider } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { useAuthStore } from '@/store/useAuthStore';
import GlobalStyles from '@/styles/GlobalStyles';
import LoadingSpinner from '@/shared/components/molecules/Loader';
import { router } from './routes/Route';

if (process.env.NODE_ENV === 'production') {
	console.log = function no_console() {};
	console.warn = function no_console() {};
	console.info = function no_console() {};
}

const App = () => {
	const { isLoading } = useAuthStore();

	// 초기 로딩 중일 때 로딩 화면 표시
	if (isLoading) {
		return <LoadingSpinner />;
	}

	return (
		<>
			<GlobalStyles />
			<ToastContainer autoClose={2000} />
			<RouterProvider router={router} />
		</>
	);
};

export default App;
